import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddGsmStockRequest } from '../models/request/gsmStock/AddGsmStockRequest';
import { GetGsmStockListPagingAndFilterRequest } from '../models/request/gsmStock/GetGsmStockListPagingAndFilterRequest';

export class GsmStockService {
    static async getGsmStockList(_selectedGsmStatusId?: string) {
        try {
            var inputObj = {
                selectedGsmStatusId: _selectedGsmStatusId
            };

            console.log('SERVICE CALL - getGsmStockList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GsmStock/getGsmStockList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportGsmStockList(inputObj: GetGsmStockListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportGsmStockList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GsmStock/exportGsmStockList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getGsmStockListPagingAndFilter(inputObj: GetGsmStockListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetGsmStockListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GsmStock/GetGsmStockListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addGsmStock(inputObj: AddGsmStockRequest) {
        try {
            console.log('SERVICE CALL - AddGsmStock', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GsmStock/AddGsmStock', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteGsmStock(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteGsmStock', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GsmStock/deleteGsmStock', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getGsmStockById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getGsmStockById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/GsmStock/getGsmStockById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}